import React from 'react'; 

import PageAbout from './PageAbout';
import PageContact from './PageContact';
import PageProjects from './PageProjects';
import PageSplash from './PageSplash';
import PageText from './PageText';

import WithConsumer from '../../context/WithConsumer';


const PageBlock = ({index,context}) => {
 	
 	if (context.posts) {
	 	
    	const posts 		= () => context.posts;
		const post 			= posts()[0];
		const block 		= post.block[index]; 
		    
		let content = '';
		
		if (block.type == 'splash') {
			content = <PageSplash block={block} />
		} else if (block.type == 'projects') {
			content = <PageProjects block={block} />
		} else if (block.type == 'about') {
			content = <PageAbout block={block} />
		} else if (block.type == 'contact') {
			content = <PageContact block={block} />
		} else if (block.type == 'text') {
			content = <PageText block={block} />
		}
    
		return content;
		
    } else {
	    
	    return null;
	    
    }

    

};
export default WithConsumer(PageBlock);